export default __webpack_public_path__ + "static/media/RTR1602V_Posterior.577dfa2d.webp";